/**
 * ============================================================================
 * GRATIA - assets/marquee.js
 * ----------------------------------------------------------------------------
 * <gratia-marquee> - infinite scrolling band. Uses GSAP when the vendor
 * bundle is loaded (smooth timeScale pause on hover); otherwise falls back to
 * the pure-CSS `animate-marquee` keyframe. Honours prefers-reduced-motion.
 * ============================================================================
 */
(function () {
  'use strict';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class GratiaMarquee extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-marquee-track]');
      if (!track || reduceMotion) return;

      const duration = parseFloat(this.dataset.speed) || 30;
      const reverse = this.dataset.direction === 'right';
      const pause = this.hasAttribute('data-pause');

      if (window.gsap) {
        track.style.animation = 'none';
        this.tween = window.gsap.fromTo(
          track,
          { xPercent: reverse ? -50 : 0 },
          { xPercent: reverse ? 0 : -50, ease: 'none', duration, repeat: -1 }
        );
        if (pause) {
          this.addEventListener('mouseenter', () => window.gsap.to(this.tween, { timeScale: 0, duration: 0.5 }));
          this.addEventListener('mouseleave', () => window.gsap.to(this.tween, { timeScale: 1, duration: 0.5 }));
        }
      } else {
        track.classList.add('animate-marquee');
        if (reverse) track.style.animationDirection = 'reverse';
        if (pause) {
          this.addEventListener('mouseenter', () => (track.style.animationPlayState = 'paused'));
          this.addEventListener('mouseleave', () => (track.style.animationPlayState = 'running'));
        }
      }
    }
    disconnectedCallback() {
      this.tween?.kill();
    }
  }

  if (!customElements.get('gratia-marquee')) customElements.define('gratia-marquee', GratiaMarquee);
})();
